document.addEventListener("DOMContentLoaded", () => {
  // --- 定義 ---
  const drawerIcon = document.querySelector(".js-drawer-icon");
  const drawer = document.querySelector("#js-drawer");
  // ドロワー内のページ内リンク
  const drawerNavItems = document.querySelectorAll('.p-drawer__inner a[href^="#"]');
  const header = document.querySelector("header");
  // ヘッダーの高さを取得 (ヘッダー要素が存在しない場合も考慮)
  const headerHeight = header ? header.offsetHeight : 0;
  const breakpoint = 768;
  // すべてのページ内リンク
  const links = document.querySelectorAll('a[href^="#"]');

  // --- ハンバーガーメニュー (ドロワー) 機能 ---

  // メニューを開く処理
  const openMenu = () => {
    if (drawer && drawerIcon) {
      // 要素が存在するか確認
      drawer.classList.add("js-show");
      drawerIcon.classList.add("js-show");

      document.body.classList.add("is-drawer-open");

      // ドロワーが開いている時はヘッダーを常に表示
      if (header) {
        header.classList.remove("is-header-hidden");
      }
    }
  };

  // メニューを閉じる処理
  const closeMenu = () => {
    if (drawer && drawerIcon) {
      // 要素が存在するか確認
      drawer.classList.remove("js-show");
      drawerIcon.classList.remove("js-show");
      document.body.classList.remove("is-drawer-open");
    }
  };

  // メニューの開閉を切り替える処理
  const toggleMenu = () => {
    if (drawer && drawer.classList.contains("js-show")) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  // ウィンドウのリサイズ時の処理
  const handleResize = () => {
    const windowWidth = window.innerWidth;
    // ウィンドウ幅がブレークポイントより大きく、かつドロワーが開いている場合は閉じる
    if (windowWidth > breakpoint && drawer && drawer.classList.contains("js-show")) {
      closeMenu();
    }
  };

  // メニュー外をクリックしたときの処理
  const handleClickOutside = (event) => {
    // ドロワーが開いていて、かつクリックされた要素がドロワーの内部でもドロワーアイコンでもない場合
    if (drawer && drawerIcon && drawer.classList.contains("js-show") && !drawer.contains(event.target) && !drawerIcon.contains(event.target)) {
      closeMenu();
    }
  };

  // --- スムーススクロール機能 ---

  // アンカーリンクによるスクロール中・直後はヘッダーを表示しないためのフラグ
  let isAnchorScrolling = false;
  let anchorScrollEnded = false; // アニメーション完了後、ユーザーの上スクロールでフラグ解除
  // 別ページからのアンカー時など、完了直後の scroll 揺れで解除されないよう上スクロール判定に閾値を設ける
  const ANCHOR_SCROLL_UP_THRESHOLD = 15;

  // 指定位置へスムーススクロールする関数
  const smoothScrollTo = (targetPosition, duration = 1000, options = {}) => {
    const start = options.startPosition !== undefined ? options.startPosition : window.scrollY;
    let startTime = null;
    const fromAnchor = options.fromAnchor === true;

    if (fromAnchor) {
      isAnchorScrolling = true;
      anchorScrollEnded = false;
      header?.classList.add("is-header-hidden");
    }

    // イージング関数 (easeInOutCubic: 開始・終了ともに滑らかに加速・減速)
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

    // スクロールアニメーションをフレームごとに実行
    const animateScroll = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1); // 進行度 (0から1)
      const easeProgress = ease(progress); // イージング適用後の進行度
      const scrollAmount = start + (targetPosition - start) * easeProgress; // スクロール量

      window.scrollTo(0, scrollAmount); // 実際にスクロールを実行

      // アニメーションが完了していなければ次のフレームを要求
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      } else if (fromAnchor) {
        // アニメーション完了後、ユーザーの上スクロールと区別するため少し待ってからフラグを有効化
        setTimeout(() => {
          anchorScrollEnded = true;
        }, 150);
      }
    };

    requestAnimationFrame(animateScroll); // アニメーション開始
  };

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href");

      if (href && href.startsWith("#")) {
        // ページ内リンクならスムーススクロール
        e.preventDefault();

        const target = href === "#" ? document.documentElement : document.querySelector(href);

        if (target) {
          const targetRect = target.getBoundingClientRect().top;
          const targetPosition = targetRect + window.scrollY;

          smoothScrollTo(targetPosition, 1000, { fromAnchor: true });
        }
      }
    });
  });

  // ハンバーガーアイコンがクリックされたとき
  if (drawerIcon) {
    // 要素が存在するか確認
    drawerIcon.addEventListener("click", toggleMenu);
  }

  // ウィンドウがリサイズされたとき
  window.addEventListener("resize", handleResize);

  // ドキュメント全体がクリックされたとき (メニュー外クリック用)
  document.addEventListener("click", handleClickOutside);

  // ドロワー内のナビゲーションリンクがクリックされたとき
  drawerNavItems.forEach((item) => {
    item.addEventListener("click", (event) => {
      event.preventDefault(); // デフォルトのリンク動作をキャンセル
      closeMenu(); // ドロワーを閉じる

      // ドロワーを閉じた後、そのリンクに対応する位置へスムーススクロールを実行
      const href = event.currentTarget.getAttribute("href");
      const target = href === "#" ? document.documentElement : document.querySelector(href);

      if (target) {
        const targetRect = target.getBoundingClientRect().top;
        const targetPosition = targetRect + window.scrollY;

        setTimeout(() => {
          smoothScrollTo(targetPosition, 1000, { fromAnchor: true });
        }, 50);
      }
    });
  });

  // 別ページ・別タブからのアンカーリンク: ハッシュはheadで除去済み → ページ準備後にスムーススクロール
  const savedHash = window.__savedHash;

  const scrollToHashFromExternal = () => {
    if (!savedHash || savedHash === "#") return;
    // overflow を解除
    document.documentElement.style.overflow = "";
    // ハッシュをURLに復元（replaceState はスクロールを発生させない）
    history.replaceState(null, "", location.pathname + location.search + savedHash);
    const target = document.querySelector(savedHash);
    if (target) {
      // ブラウザがどこにスクロールしていても、要素の絶対位置を算出
      // スクロール時はヘッダー非表示のためオフセット不要
      const absoluteTop = target.getBoundingClientRect().top + window.scrollY;
      const targetPosition = absoluteTop;
      // startPosition: 0 を明示 → 最初のフレームから scrollTo(0, 0) が発行され、TOP0 から開始
      smoothScrollTo(targetPosition, 1000, { fromAnchor: true, startPosition: 0 });
    }
  };

  window.addEventListener("page-ready-for-hash", scrollToHashFromExternal);

  // --- ヘッダー状態管理（全ページ共通: スクロール表示/非表示、ページ別: is-white / is-another / is-contact） ---
  if (header) {
    const body = document.body;
    const stateClasses = ["is-white", "is-another", "is-contact"];
    let lastScrollY = window.scrollY;
    let ticking = false;

    const getPageType = () => {
      if (body.classList.contains("home")) return "home";
      if (document.getElementById("page-partner")) return "partner";
      const main = document.querySelector("main");
      if (main && (main.id === "contact" || main.id === "contact-confirm")) return "contact";
      return "another";
    };

    // 上スクロール時のチラつき防止: is-white の境界にヒステリシス（px）
    const IS_WHITE_HYSTERESIS = 30;

    const updateHeaderStateClasses = () => {
      const pageType = getPageType();
      header.classList.remove("is-another", "is-contact");

      if (pageType === "contact") {
        header.classList.remove("is-white");
        header.classList.add("is-contact");
        return;
      }
      if (pageType === "another") {
        header.classList.add("is-another");
        if (window.scrollY <= 0) {
          header.classList.remove("is-white");
        } else {
          header.classList.add("is-white");
        }
        return;
      }
      if (pageType === "home") {
        const strengths = document.querySelector(".p-strengths");
        const strengthsTop = strengths ? strengths.getBoundingClientRect().top : 1;
        if (strengthsTop <= 0) {
          header.classList.add("is-white");
        } else if (strengthsTop > IS_WHITE_HYSTERESIS) {
          header.classList.remove("is-white");
        }
        return;
      }
      if (pageType === "partner") {
        const partnerFv = document.querySelector(".p-partner-fv");
        const partnerFvBottom = partnerFv ? partnerFv.getBoundingClientRect().bottom : 0;
        if (partnerFvBottom <= 0) {
          header.classList.add("is-white");
        } else if (partnerFvBottom > IS_WHITE_HYSTERESIS) {
          header.classList.remove("is-white");
        }
      }
    };

    const updateHeaderScrollVisibility = () => {
      // ドロワーが開いている時はヘッダーを常に表示
      if (body.classList.contains("is-drawer-open")) {
        header.classList.remove("is-header-hidden");
        return;
      }

      const scrollY = window.scrollY;
      // アンカーリンクでスクロールした直後はヘッダーを表示しない（ユーザーが上スクロールするまで）
      // iOS ではアニメーション前や完了直後に scrollY が 0 で発火することがあるため、scrollY <= 0 では解除しない
      if (isAnchorScrolling) {
        const scrolledUp = anchorScrollEnded && scrollY < lastScrollY - ANCHOR_SCROLL_UP_THRESHOLD;
        if (scrolledUp) {
          isAnchorScrolling = false;
          header.classList.remove("is-header-hidden");
        }
        lastScrollY = scrollY;
        return;
      }

      if (scrollY <= 0) {
        header.classList.remove("is-header-hidden");
      } else if (scrollY > lastScrollY) {
        header.classList.add("is-header-hidden");
      } else {
        header.classList.remove("is-header-hidden");
      }
      lastScrollY = window.scrollY;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateHeaderScrollVisibility();
          updateHeaderStateClasses();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    updateHeaderScrollVisibility();
    updateHeaderStateClasses();
  }

  // --- スクロールトップ: 200px 以上でフェードイン ---
  const scrollTopEl = document.querySelector(".p-scroll-top");
  const SCROLL_TOP_THRESHOLD = 200;
  if (scrollTopEl) {
    const updateScrollTopVisibility = () => {
      if (window.scrollY >= SCROLL_TOP_THRESHOLD) {
        scrollTopEl.classList.add("is-visible");
      } else {
        scrollTopEl.classList.remove("is-visible");
      }
    };
    window.addEventListener("scroll", updateScrollTopVisibility, { passive: true });
    updateScrollTopVisibility();
  }

  // --- FV 横スクロールバー：スクロール量に応じてactiveを更新 ---
  const fvBoxesWrapper = document.getElementById("js-fv-boxes-wrapper");
  const fvBoxesScrollbarTrack = document.querySelector(".p-fv__top__boxes-scrollbar-track");
  const updateFvScrollbarProgress = () => {
    if (!fvBoxesWrapper || !fvBoxesScrollbarTrack) return;
    const maxScroll = fvBoxesWrapper.scrollWidth - fvBoxesWrapper.clientWidth;
    // 初期30%を0として、0〜100%スクロールで 30%→100% に伸びる
    const progress = maxScroll <= 0 ? 0.22 : 0.22 + 0.78 * (fvBoxesWrapper.scrollLeft / maxScroll);
    fvBoxesScrollbarTrack.style.setProperty("--fv-scroll-progress", progress);
  };
  if (fvBoxesWrapper && fvBoxesScrollbarTrack) {
    fvBoxesWrapper.addEventListener("scroll", updateFvScrollbarProgress, { passive: true });
    updateFvScrollbarProgress();
    window.addEventListener("resize", updateFvScrollbarProgress);
  }

  // --- FV Scroll ボタン: ページ下部400pxで非表示 ---
  const fvScrollEl = document.querySelector(".p-fv__scroll");
  const FV_SCROLL_BOTTOM_THRESHOLD = 800;
  if (fvScrollEl) {
    const updateFvScrollVisibility = () => {
      const distanceFromBottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
      if (distanceFromBottom <= FV_SCROLL_BOTTOM_THRESHOLD) {
        fvScrollEl.classList.add("is-hidden");
      } else {
        fvScrollEl.classList.remove("is-hidden");
      }
    };
    window.addEventListener("scroll", updateFvScrollVisibility, { passive: true });
    updateFvScrollVisibility();
  }

  // --- 言語切替ボタン: data-alternate-url へ遷移 ---
  document.querySelectorAll(".c-language-button[data-alternate-url]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const url = btn.getAttribute("data-alternate-url");
      if (url) {
        window.location.href = url;
      }
    });
  });

  // --- 初期処理 ---
});
